<template>
  <div class="flex_vh100 home">
    <div>
      <!-- 顶部导航 -->
      <van-nav-bar
        title="组局报表"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      >
        <template #right>
          <van-icon
            name="filter-o"
            size="20"
            @click="showFilter = !showFilter"
          />
        </template>
      </van-nav-bar>
    </div>
    <div class="flex_vh100">
      <UniversalSearch
        v-show="showFilter"
        ref="universalSearch"
        title="筛选"
        :initial-form-data="formData"
        @search="handleSearch"
        @reset="handleReset"
      >
        <!-- 自定义搜索内容插槽 -->
        <template #search-content="{ formData }">
          <div class="search-fields">
            <!-- 日期类型选择 -->
            <van-dropdown-menu>
              <van-dropdown-item
                v-model="formData.dateType"
                :options="tiemTypeList"
                title="日期类型"
              />
            </van-dropdown-menu>

            <!-- 自定义日期区间（仅当选择自定义时显示） -->
            <div v-if="formData.dateType === 4" class="custom-date-range">
              <van-field
                readonly
                clickable
                :value="formData.datevalue"
                placeholder="请选择日期范围"
                @click="showCalendarEVE(formData)"
              >
                <template #left-icon>
                  <van-icon name="calendar-o" />
                </template>
              </van-field>
            </div>
            <van-dropdown-menu>
              <!-- 账户类型选择 -->
              <van-dropdown-item
                v-model="formData.accountType"
                :options="accountTypeList"
                title="账户类型"
              />
            </van-dropdown-menu>
          </div>
        </template>
      </UniversalSearch>

      <!-- 列表 -->
      <ListPage
        ref="listPage"
        :request-api="_getPrivateTeamReportStatistics"
        :params="searchInfo"
        class="flex_vh100"
      >
        <template #default="{ list }">
          <div class="product-grid">
            <div v-for="item in list" :key="item.id" class="product-item">
              <van-cell-group>
                <van-cell
                  title="日期类型"
                  :value="
                    item.dateType == 1
                      ? '按周'
                      : item.dateType == 2
                      ? '按月'
                      : item.dateType == 3
                      ? '按季'
                      : '自定义（按天统计）'
                  "
                ></van-cell>
                <van-cell
                  title="日期"
                  :value="
                    item.startDate.substring(0, 10) +
                    '至' +
                    item.endDate.substring(0, 10)
                  "
                ></van-cell>
                <van-cell
                  title="组局次数"
                  :value="item.PrivateTeamCount"
                ></van-cell>
                <van-cell
                  title="最后组局时间"
                  :value="item.LastTime"
                ></van-cell>
              </van-cell-group>
            </div>
          </div>
        </template>
      </ListPage>
    </div>

    <!-- 日期区间选择器 -->
    <van-calendar
      v-model="showCalendar"
      type="range"
      :min-date="minDate"
      :max-date="maxDate"
      :max-range="365"
      @confirm="onConfirm"
      :show-confirm="false"
    />
  </div>
</template>

<script>
import ListPage from "./controls/ListPage.vue";
import UniversalSearch from "./controls/UniversalSearch.vue";
import { GetPrivateTeamReportStatistics } from "../api/financeapi.js";
export default {
  name: "ReportStatistics_PrivateTeam",
  components: { ListPage, UniversalSearch },
  data() {
    const now = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(now.getFullYear() - 1);
    return {
      showFilter: false,
      isCollapsed: false, // 搜索区域是否收缩
      formData: {
        dateType: 4,
        accountType: 1,
        accountId: "",
        datevalue: "",
        startDate: null,
        endDate: null,
      },
      searchInfo: {
        dateType: 4,
        accountType: 1,
        accountId: "",
        datevalue: "",
        startDate: null,
        endDate: null,
      },

      tiemTypeList: [
        { value: 1, text: "按周" },
        { value: 2, text: "按月" },
        { value: 3, text: "按季度" },
        { value: 4, text: "自定义（按天统计）" },
      ],

      accountTypeList: [
        { value: 1, text: "按玩家" },
        { value: 2, text: "按代理" },
        { value: 3, text: "按子代理" },
      ],

      showCalendar: false,

      // 日期限制
      minDate: oneYearAgo,
      maxDate: now,
    };
  },
  watch: {
    showFilter(val) {
      if (this.$refs.universalSearch) {
        val ? this.$refs.universalSearch.expand() : this.$refs.universalSearch.collapse();
      }
    },
    $route(to) {
      // 路由变化时更新激活的标签
      if (to.name == "ReportStatistics_PrivateTeam") {
      }
    },
  },
  computed: {},
  methods: {
    goBack() {
      this.$router.go(-1); // 后退一步
    },
    // 执行搜索
    handleSearch(searchParams) {
      // 当dateType为4(自定义)但未选择日期时，startDate和endDate传null
      if (searchParams.dateType === 4) {
        searchParams.startDate = searchParams.startDate || null;
        searchParams.endDate = searchParams.endDate || null;
      }
      this.searchInfo = searchParams;
    },

    // 重置搜索条件
    handleReset() {
      this.formData = {
        dateType: 4,
        accountType: 1,
        accountId: "",
        datevalue: "",
        startDate: null,
        endDate: null,
      };
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day} ${"00"}:${"00"}:${"00"}`;
    },
    showCalendarEVE(item) {
      this.showCalendar = true;
      this.formData = item;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.showCalendar = false;
      this.formData.datevalue = `${this.formatDate(start)} - ${this.formatDate(
        end
      )}`;
      this.formData.startDate = `${this.formatDate(start)}`;
      this.formData.endDate = `${this.formatDate(end)}`;
    },

    //组局报表
    _getPrivateTeamReportStatistics(params) {
      return GetPrivateTeamReportStatistics(params);
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* 隐藏 UniversalSearch 自带的 header，切换按钮已在导航栏 */
:deep(.collapsible-search .search-header) {
  display: none;
}

.search-fields {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.search-row {
  display: flex;
  gap: 10px;
}

.search-row[style*="column"] {
  flex-direction: column;
}

.search-type {
  flex-shrink: 0;
  width: 100%;
}

.search-type :deep(.van-dropdown-menu__bar) {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: none;
  height: 36px;
  border: 1px solid #ebedf0;
}

.search-type :deep(.van-dropdown-menu__title) {
  padding: 0 10px;
  line-height: 34px;
  font-size: 13px;
}

.search-input {
  flex: 1;
}

.search-input :deep(.van-field) {
  background-color: #fff;
  border-radius: 6px;
  padding: 6px 10px;
  border: 1px solid #ebedf0;
}

.search-input :deep(.van-field__control) {
  font-size: 13px;
}

.search-input :deep(.van-field__right-icon),
.search-input :deep(.van-field__left-icon) {
  color: #1989fa;
  cursor: pointer;
}

.product-item {
  background-color: #fff;
  border-bottom: 1px solid #f5f6f8;
  margin-bottom: 10px;
}

.product-item :deep(.van-cell-group) {
  background-color: transparent;
}

.product-item :deep(.van-cell-group::after) {
  display: none;
}

.product-item :deep(.van-cell) {
  padding: 10px 14px;
  font-size: 13px;
  line-height: 1.5;
}

.product-item :deep(.van-cell::after) {
  display: none;
}

.product-item :deep(.van-cell__title) {
  color: #323233;
  font-size: 13px;
}

.product-item :deep(.van-cell__value) {
  color: #969799;
  font-size: 13px;
}

.cloth-icon {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  object-fit: cover;
  margin-right: 6px;
}
.custom-cell {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.cell-title {
  font-size: 13px;
  color: #323233;
}

.cell-label {
  font-size: 11px;
  color: #969799;
}

.cell-value {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #969799;
  font-size: 13px;
}

.cell-left {
  flex: 1;
}

.accountStyle {
  text-align: right;
}
</style>
